module.exports = __webpack_public_path__ + "static/media/test-auditif-resultat.213aef0b.png";